import React, { useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

import {
  AiOutlineDashboard
} from "react-icons/ai";
import {
  FiUser,
  FiUsers
} from "react-icons/fi";
import { BiSupport } from "react-icons/bi";
import { 
  FaBook, FaBoxOpen, FaChartLine, FaClipboardList, FaCreditCard, FaFileAlt, 
  FaFileInvoice, FaFileInvoiceDollar, FaLandmark, FaListAlt, FaListUl, 
  FaReceipt, FaShoppingCart, FaTruckMoving, FaUniversity, FaUserAlt, 
  FaUsers, FaUserTie, FaWarehouse 
} from "react-icons/fa";
import { RiCoupon4Fill } from "react-icons/ri";
import { RiShieldKeyholeLine } from "react-icons/ri";
import { MdOutlineAccountBalance } from "react-icons/md";

import { TbTruckReturn } from "react-icons/tb";
import { MdDashboard, MdOutlineWarehouse } from "react-icons/md";
import { VStack } from "@chakra-ui/react";

const Sidebar = ({ onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const links = [
    { to: "/", icon: <MdDashboard size={25} />, label: "Dashboard" },
    { to: "/otp", icon: <RiShieldKeyholeLine size={25} />, label: "Otp" },
    { to: "/coupon", icon: <RiCoupon4Fill size={25} />, label: "Coupon" },
    { to: "/loan", icon: <MdOutlineAccountBalance size={25} />, label: "Loan" },
    { to: "/products", icon: <FaBoxOpen size={25} />, label: "Products" },
    { to: "/inventory", icon: <FaWarehouse size={25} />, label: "Inventory" },
    { to: "/vendors-list", icon: <FaUserTie size={25} />, label: "Vendor" },
    { to: "/customer-list", icon: <FaUsers size={25} />, label: "Customer List" },
    { to: "/orders", icon: <FaListAlt size={25} />, label: "Orders" },
    { to: "/credit", icon: <FaCreditCard size={25} />, label: "Credit", hasState: true },
    { to: "/purchase", icon: <FaShoppingCart size={25} />, label: "Purchase" }, 
    { to: "/defective-return", icon: <TbTruckReturn size={25} />, label: "Defective Return" },
    { to: "/quotation", icon: <FaFileInvoiceDollar size={25} />, label: "Quotation" },
    { to: "/purchase-order", icon: <FaClipboardList size={25} />, label: "Purchase Order" },
    { to: "/payment-refund", icon: <MdOutlineWarehouse size={25} />, label: "Payment Refund" },
    { to: "/dp-list", icon: <FaListUl size={25} />, label: "DP List" },
    { to: "/driver-list", icon: <FaUserAlt size={25} />, label: "Driver" },
    { to: "/vehicle-list", icon: <FaTruckMoving size={25} />, label: "Vehicle" },
    { to: "/banks", icon: <FaUniversity size={25} />, label: "Banks" },
    { to: "/support", icon: <BiSupport size={25} />, label: "Support" },
    { to: "/notifications", icon: <MdDashboard size={25} />, label: "Notifications" },
    { to: "/receipt", icon: <FaReceipt size={25} />, label: "Receipt" },
    { to: "/ledger-reports", icon: <FaBook size={25} />, label: "Ledger Reports" },
    { to: "/sales-reports", icon: <FaChartLine size={25} />, label: "Sales Reports" },
    { to: "/bank-reports", icon: <FaLandmark size={25} />, label: "Bank Reports" },
    { to: "/receipt-reports", icon: <FaFileInvoice size={25} />, label: "Receipt Reports" },
    { to: "/purchase-reports", icon: <FaFileAlt size={25} />, label: "Purchase Reports" },
  ];

  const handleLinkClick = (link, e) => {
    // Prevent any default behavior
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // Navigate with state if needed
    if (link.hasState) {
      navigate(link.to, { state: { fromSidebar: true } });
    } else {
      navigate(link.to);
    }

    // Close sidebar (for mobile/drawer)
    if (onClose) {
      onClose();
    }
  };

  return (
    <VStack align="start" w="full" paddingTop="10px">
      {links.map((link) => {
        const isActiveLink = location.pathname === link.to;
        
        return (
          <div
            key={link.to}
            onClick={(e) => handleLinkClick(link, e)}
            className={`df alc mt10 ph ${
              isActiveLink
                ? "link activelink-bg link-br"
                : "link unactivelink-bg"
            }`}
            style={{ cursor: "pointer" }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                handleLinkClick(link, e);
              }
            }}
          >
            {link.icon}
            {link.label}
          </div>
        );
      })}
    </VStack>
  );
};

export default Sidebar;